import React from 'react';
import times from 'lodash/times';

import { Box } from '@lyearn/ui';
import { DropOverContainer } from '@/components/DragDrop';
import useDraggableList from '@/modules/corporate/components/DraggableList/hooks/useDraggableList';

import DraggableListItem from './components/DraggableListItem';
import { DraggableListProps } from './types';

function DraggableList(props: DraggableListProps) {
  const {
    allowDropOnStart,
    className,
    classes,
    disabled,
    totalCount,
    renderItem,
    onDrop: onDropProp,
    keyExtractor,
  } = props;
  const { draggingItemRef, getDropOverContainerProps, onDrop } = useDraggableList({
    onDrop: onDropProp,
  });

  if (!totalCount) {
    return null;
  }

  return (
    <Box className={className}>
      {allowDropOnStart ? (
        <DropOverContainer className="-mt-24" {...getDropOverContainerProps()}>
          <Box className="h-24" />
        </DropOverContainer>
      ) : null}
      {times(totalCount, (index) => (
        <DraggableListItem
          key={keyExtractor ? keyExtractor(index) : index}
          className={classes?.itemDropOverContainer}
          disabled={disabled}
          draggingItemRef={draggingItemRef}
          index={index}
          renderItem={renderItem}
          onDrop={onDrop}
        />
      ))}
    </Box>
  );
}

export default DraggableList;
